import {StyleSheet} from '@react-pdf/renderer'
import theme from '../../themes/pTheme/pTheme'

// default unit is pt, Based on the standard 72 dpi PDF document), hence width,height,spacing etc are in pt. For A4, the width is 596 pt and height is 842 pt
export const styles = StyleSheet.create({
  timeStampContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: 5,
    color: theme.palette.hpBaseDark
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 5
  },
  logo: {
    height: 80
  },

  textRegular: {
    fontSize: 9 // 9pt as per the standard 72 dpi PDF document
  },

  footerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingVertical: 8,
    paddingHorizontal: 10,
    backgroundColor: theme.palette.hpBaseLighter
  },
  footerText: {
    fontSize: 7.25, // 7.25pt as per the standard 72 dpi PDF document
    color: theme.palette.hpBaseDark
  }
})
